import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Amplify } from 'aws-amplify';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: 'us-east-2_bnrjiVnsu',
      userPoolClientId: '6s867ofd3mo6an8nj96b8r9i23',
      loginWith: {
        oauth: {
          domain: 'auth.monivue.io',
          scopes: ['phone', 'openid'],
          redirectSignIn: ['https://thriveatmontvale.monivue.io'],
          redirectSignOut: ['https://thriveatmontvale.monivue.io'],
          responseType: 'code'
        }
      }
    }
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();